import React, { useRef,useEffect  } from 'react';
import Slider from 'react-slick';
import image1 from '../Images/Portfolio-1.png';
import image2 from '../Images/movie2.png';
import image3 from '../Images/movie3.png';
import image4 from '../Images/movie4.png';
import image5 from '../Images/movie5.png';
import image6 from '../Images/movie6.png';
import image7 from '../Images/movie7.png';
import { Link } from 'react-router-dom'; 

const slides = [
  { id: 1, img: image1, title: 'Lost & Found',link: '/page' },
  { id: 2, img: image2, title: 'Magnolia ',link: '/page-1' },
  { id: 3, img: image3, title: 'Lifeline' ,link: '/page-3'},
  { id: 4, img: image4, title: 'Spy ',link: '/page-4' },
  { id: 5, img: image5, title: 'JBL TVC ',link: '/page-5' },
  { id: 6, img: image6, title: 'All Alone ',link: '/page-6' },
  { id: 7, img: image7, title: 'The Last Dorito ',link: '/page-7' },
];

const ImageGridSlider = () => {
  const sliderRef = useRef(null);

  const settings = {
    centerMode: true,
    centerPadding: '25%',  // For larger screens
    slidesToShow: 1,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'ease',
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768, // Tablets and below
        settings: {
          centerPadding: '15%',  // Less padding on smaller screens
        },
      },
      {
        breakpoint: 480, // Mobile devices
        settings: {
          centerPadding: '10%',  // Even less padding for mobile
        },
      },
    ],
  };

  const handleWheel = (event) => {
    if (event.deltaY > 0) {
      sliderRef.current.slickNext();
    } else {
      sliderRef.current.slickPrev();
    }
  };
  useEffect(() => {
    // Attach the wheel event listener to the window object
    window.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      // Clean up the event listener on component unmount
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <div className="slider-container">
      <Slider ref={sliderRef} {...settings}>
        {slides.map(slide => (
          <div key={slide.id} className="slider-item">
             <Link to={slide.link}> {/* Each image points to a unique link */}
            <img src={slide.img} alt={slide.title} className="slider-image" />
          
            <div className="slide-caption">
              <h3>{slide.title}</h3>
            </div>
            </Link>
          </div>
        ))}
      </Slider>
     
    </div>
  );
};

export default ImageGridSlider;
